import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Check, Phone } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import WhatsAppButton from '../components/WhatsAppButton';
import { useLanguage, getPageTexts } from '../i18n/pageTranslations';

const Papada = () => {
  const lang = useLanguage();
  const t = getPageTexts('papada', lang);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-[#FDFBF8]">
      <Header />
      
      {/* Hero */}
      <section className="pt-32 pb-20 bg-[#FDFBF8]">
        <div className="container mx-auto px-6 max-w-6xl">
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            <div>
              <p className="text-sm tracking-[0.3em] uppercase text-[#B8975A] mb-6">{t.category}</p>
              <h1 className="font-serif text-5xl md:text-6xl text-[#1C1C1A] mb-6 leading-tight">
                {t.title}
              </h1>
              <div className="w-20 h-[2px] bg-[#B8975A] mb-8"></div>
              <p className="text-lg text-[#4A4845] leading-relaxed mb-8">
                {t.heroDesc}
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                <Link 
                  to="/contacto"
                  className="inline-flex items-center justify-center gap-2 bg-[#B8975A] text-white px-8 py-4 text-sm tracking-wider uppercase hover:bg-[#96784a] transition-colors"
                >
                  {t.requestAssessment}
                  <ArrowRight size={16} />
                </Link>
                <a 
                  href="tel:+34952764547"
                  className="inline-flex items-center justify-center gap-2 border border-[#1C1C1A] text-[#1C1C1A] px-8 py-4 text-sm tracking-wider uppercase hover:bg-[#1C1C1A] hover:text-white transition-colors"
                >
                  <Phone size={16} />
                  {t.callNow}
                </a>
              </div>
            </div>
            <div className="relative">
              <div className="absolute -top-4 -left-4 w-24 h-24 border-t-2 border-l-2 border-[#B8975A]"></div>
              <img 
                src="/images/placeholder-tratamiento.svg"
                alt={t.title}
                className="w-full h-auto"
              />
              <div className="absolute -bottom-4 -right-4 w-24 h-24 border-b-2 border-r-2 border-[#B8975A]"></div>
            </div>
          </div>
        </div>
      </section>

      {/* Técnicas */}
      <section className="py-20 bg-[#1C1C1A]">
        <div className="container mx-auto px-6 max-w-6xl">
          <div className="text-center mb-16">
            <p className="text-sm tracking-[0.3em] uppercase text-[#B8975A] mb-6">{t.techniquesTitle}</p>
            <h2 className="font-serif text-4xl text-white">{t.techniquesSubtitle}</h2>
          </div>
          <div className="grid md:grid-cols-3 gap-8">
            {t.techniques && t.techniques.map((tecnica, index) => (
              <div key={index} className="p-8 border border-[#B8975A]/30 hover:border-[#B8975A] transition-colors">
                <span className="text-[#B8975A]/40 font-serif text-sm">0{index + 1}</span>
                <h3 className="font-serif text-2xl text-white mt-2 mb-4">{tecnica.title}</h3>
                <p className="text-white/70">{tecnica.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Beneficios */}
      <section className="py-20 bg-[#F0EDE7]">
        <div className="container mx-auto px-6 max-w-4xl">
          <div className="text-center mb-12">
            <p className="text-sm tracking-[0.3em] uppercase text-[#B8975A] mb-6">{t.benefitsTitle}</p>
            <h2 className="font-serif text-4xl text-[#1C1C1A]">{t.benefitsSubtitle}</h2>
          </div>
          <div className="grid md:grid-cols-2 gap-6">
            {t.benefits && t.benefits.map((beneficio, index) => (
              <div key={index} className="flex items-start gap-4 p-4 bg-white">
                <div className="w-6 h-6 bg-[#B8975A]/20 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <Check size={14} className="text-[#B8975A]" />
                </div>
                <span className="text-[#4A4845]">{beneficio}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 bg-[#FDFBF8]">
        <div className="container mx-auto px-6 max-w-3xl text-center">
          <h2 className="font-serif text-4xl text-[#1C1C1A] mb-6">
            {t.ctaTitle}
          </h2>
          <p className="text-[#4A4845] mb-10">
            {t.ctaDesc}
          </p>
          <Link 
            to="/contacto"
            className="inline-flex items-center gap-2 bg-[#B8975A] text-white px-10 py-4 text-sm tracking-wider uppercase hover:bg-[#96784a] transition-colors"
          >
            {t.contact}
            <ArrowRight size={16} />
          </Link>
        </div>
      </section>

      <Footer />
      <WhatsAppButton />
    </div>
  );
};

export default Papada;
